import { DataConnectorType, DataConnector } from '../domainObjects/dataConnector';
import { DataSourceType } from '../domainObjects/dataSourceType';

export class GetUnifiedColmappingMapLibRequest {
    organizationId: number;
    dataSourceType: DataSourceType;
    dataConnectorType: DataConnectorType;
    dataConnector: DataConnector;
    ingestConfigGUID: string = "";
    excelTurboMode?:boolean = true;
    isMultiTabIngest?: boolean = false;
    targetDataFarm?: number = 0;

    constructor(organizationId: number, dataSourceType: DataSourceType, dataConnectorType: DataConnectorType, dataConnector: DataConnector, ingestConfigGUID: string, excelTurboMode?: boolean, isMultiTabIngest?: boolean, targetDataFarm?: number) {
        this.organizationId = organizationId;
        this.dataSourceType = dataSourceType;
        this.dataConnectorType = dataConnectorType;
        this.dataConnector = dataConnector;
        this.ingestConfigGUID = ingestConfigGUID;
        this.excelTurboMode = excelTurboMode;
        this.isMultiTabIngest = isMultiTabIngest;
        this.targetDataFarm = targetDataFarm;
    }
}

